import { StarsButton, Translation } from '@ps/web-shared-components';
import classnames from 'clsx';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { useHomeGamesWidget } from '../../model';
import LeaderBoard from '../Club/Wall/components/LeaderBoard/LeaderBoard';
import WallPosts from '../Club/Wall/components/WallPosts';

import {
  TXTCLI_Club_Wall_1,
  TXTWCL_Go_to_Club_Wall,
  TXTWCL_No_messages_yetX_Start_the_con_ELL
} from './RightSideBar.messages.json';
import styles from './RightSideBar.scss';
import MessagesIcon from './assets/messages-icon.svg';
import useRightSideMaxHeight from './hooks/useRightSideMaxHeight';

interface Props {
  isRightSide?: boolean;
}

const RightSideBar: React.FC<Props> = (props) => {
  const { widgetSelect } = useHomeGamesWidget();
  const { clubId } = useParams<{ clubId: string }>();
  const pathname = `/homegames/clubs/${clubId}/wall/`;
  const wallMessages = useSelector(widgetSelect.wallPosts);
  const { rightSideRef } = useRightSideMaxHeight<HTMLFormElement>();
  const { messagesRef } = useRightSideMaxHeight<HTMLDivElement>();
  const ranks = useSelector(widgetSelect.clubSeasonRanks);

  return (
    <section id="rightBar" className={styles.container} ref={rightSideRef}>
      <LeaderBoard ranks={ranks} />
      <div className={styles.wallContainer}>
        <div className={styles.title}>
          <Translation tagName="p" {...TXTCLI_Club_Wall_1} />
        </div>
        <div className={styles.buttonContainer}>
          <StarsButton
            className={classnames(styles.sideButton, styles.btnBorder)}
            block
            variant="casino"
            href={pathname}
            translation={TXTWCL_Go_to_Club_Wall}
          />
        </div>
        <div className={styles.wallWrapper} ref={messagesRef}>
          {isEmpty(wallMessages) ? (
            <div className={classnames(styles.messageContainer, styles.emptyMessage)}>
              <MessagesIcon />
              <div>
                <Translation tagName="p" {...TXTWCL_No_messages_yetX_Start_the_con_ELL} />
              </div>
            </div>
          ) : (
            <div className={styles.messageContainer}>
              <WallPosts loading isManager isRightSide posts={wallMessages} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default RightSideBar;
